
import { createRouter, createWebHistory } from 'vue-router'
import keycloak from '@/keycloak.js'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Layout from '../Layout.vue'
import DepartmentMembershipRequestsIndexView from '../views/departments/membership/requests/DepartmentMembershipRequestsIndexView.vue'
import AbsenceRequestsIndexView from '../views/absences/requests/AbsenceRequestsIndexView.vue'
import AssessmentModelsIndexView from "../views/assessments/models/AssessmentModelsIndexView.vue"
import AssessmentModelDetailsView from "../views/assessments/models/AssessmentModelDetailsView.vue"
import TechnicalCompetenciesIndexView from "../views/assessments/competencies/technical/TechnicalCompetenciesIndexView.vue"
import PersonalCompetenciesIndexView from "../views/assessments/competencies/personal/PersonalCompetenciesIndexView.vue"
import AscendingAssessmentTestQuestionaire from '../views/assessments/questionaires/AscendingAssessmentTestQuestionaire.vue'
import AbsenceRequestGantTimeline from '../components/absences/requests/AbsenceRequestGantTimeline.vue'
import AbsenceRequestsMapView from '../views/absences/requests/AbsenceRequestsMapView.vue'
import AscendingAssessmentsIndexView from '../views/assessments/ascending/AscendingAssessmentsIndexView.vue'
import SelfAssessmentsIndexView from '../views/assessments/self/SelfAssessmentsIndexView.vue'
import DownwardAssessmentsIndexView from '../views/assessments/downward/DownwardAssessmentsIndexView.vue'
import AssessmentQuestionaireForm from '../components/assessments/questionaires/AssessmentQuestionaireForm.vue'
import AssessmentQuestionaireDetailsView from '../views/assessments/questionaires/AssessmentQuestionaireDetailsView.vue'
import { pinia } from '../plugins/pinia.js'
import { useSessionStore } from '../stores/SessionStore.js';
import ForbiddenView from '../views/ForbiddenView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import AbsencesManagementView from '../views/absences/requests/AbsencesManagementView.vue'
import DepartmentMembershipRequestTrackingGroupsIndexView from '../views/departments/membership/requests/tracking-groups/DepartmentMembershipRequestTrackingGroupsIndexView.vue'
import DepartmentMembershipTrackingGroupDetailsView from '../views/departments/membership/requests/tracking-groups/DepartmentMembershipTrackingGroupDetailsView.vue'
import ManageAssessmentsActivationStatusIndexView from '../views/assessments/ManageAssessmentsActivationStatusIndexView.vue'
import FormsIndexView from '../views/forms/FormsIndexView.vue'


const assessmentDetailsPermissionsByType = Object.freeze({
    self: {
        requiresAny: [
            "self.assessment.get.self",
            "self.assessment.get.any",
            "self.assessment.get.department",
        ],
        requiresAll: [],
    },
    ascending: {
        requiresAny: [
            "ascending.assessment.create.any",
            "ascending.assessment.create.department", 
            "ascending.assessment.create.self", 
            "ascending.assessment.get.any", 
            "ascending.assessment.list.any", 
            "ascending.assessment.update.any",  
        ],
        requiresAll: [],
    },
    downward: {
        requiresAny: [
            "downward.assessment.manage",
        ],
        requiresAll: [],
    },
});


const dmrTrackingGroupsPermissionsByType = Object.freeze({
  create: {
    requiresAny: [
      "user.department.membership.request.tracking-group.create",
      "user.department.membership.request.tracking-group.manage.any",

    ],
    requiresAll: [

    ],
  },
  get:  {
    requiresAny: [
      "user.department.membership.request.tracking-group.get",
      "user.department.membership.request.tracking-group.manage.manager",
      "user.department.membership.request.tracking-group.manage.tracked",
      "user.department.membership.request.tracking-group.manage.any",

    ],
    requiresAll: [

    ],
  },
  
  update: {
    requiresAny: [
      "user.department.membership.request.tracking-group.update",
      "user.department.membership.request.tracking-group.manage.manager",
      "user.department.membership.request.tracking-group.manage.tracked",
      "user.department.membership.request.tracking-group.manage.any", 

    ],
    requiresAll: [],
  },

  delete: {
    requiresAny: [
      "user.department.membership.request.tracking-group.delete",
      "user.department.membership.request.tracking-group.manage.any",
    ],
    requiresAll : [
      
    ],
  },
});

const routes = [
  { path: '/', component: Login, name: 'Login' },

  {
    path: '/admin',
    component: Layout,
    children: [
      {
        path: "forbidden",
        component: ForbiddenView,
        name: "forbidden",
      },
      {
        path: "not-found",
        component: NotFoundView,
        name: "not-found",
      },
      {
          path: "/departments/membership-requests/exports/:exportId?",
          component: () => import("../views/departments/membership/requests/DepartmentMembershipRequestsExportsView.vue"),
          name: "department-membership-request-exports",
      },
      { 
        path: '', 
        component: Dashboard,
        name: "dashboard",
      }, 
      {
        path: "/departments/membership-requests",
        component: DepartmentMembershipRequestsIndexView,
        name: "department-membership-requests-index",
        meta: {
          permissions : {
            requiresAny: [
              "user.department.membership.request.list.any",
              "user.department.membership.request.list.department",
              "user.department.membership.request.view.operators.any",
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/departments/membership-requests/tracking-groups",
        component: DepartmentMembershipRequestTrackingGroupsIndexView,
        name: "department-membership-request-tracking-groups-index",
        meta: {
          permissions : {
            requiresAny: [
              "user.department.membership.request.tracking-group.update",
              "user.department.membership.request.tracking-group.delete",
              "user.department.membership.request.tracking-group.get",
              "user.department.membership.request.tracking-group.list",
              "user.department.membership.request.tracking-group.manage.manager",
              "user.department.membership.request.tracking-group.manage.tracked",
              "user.department.membership.request.tracking-group.manage.any",
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/departments/membership-requests/tracking-groups/create",
        component: DepartmentMembershipTrackingGroupDetailsView,
        name: "department-membership-request-tracking-groups-create",
        meta: {
          permissions : {
            requiresAny: [
              "user.department.membership.request.tracking-group.create",
              "user.department.membership.request.tracking-group.manage.any",
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/departments/membership-requests/tracking-groups/:action(create|update|get|delete)/:id?",
        component: DepartmentMembershipTrackingGroupDetailsView,
        name: "department-membership-request-tracking-groups-details",
        meta: {
          permissionResolver: (to) => (
            dmrTrackingGroupsPermissionsByType[to.params.action] ?? null
          )
        },
      },
      {
        path: "/absences/requests",
        component: AbsenceRequestsIndexView,
        name: "absence-requests",
        meta: {
          permissions : {
            requiresAny: [
              "absence.request.create.any",
              "absence.request.create.department",
              "absence.request.create.self",
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/absences/requests/map",
        component: AbsenceRequestsMapView,
        name: "absence-requests-map",
        meta: {
          permissions : {
            requiresAny: [
              "absence.request.list.any",
              "absence.request.list.department",
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/absences/manage",
        component: AbsencesManagementView,
        name: "absence-manage",
        meta: {
          permissions : {
            requiresAny: [
              "absence.request.default-days.manage.department",
              "absence.request.default-days.manage.any",
            ],
            requiresAll: [

            ],
          },
        },
      },
      // NEXUS-87 - Alice Serina - 03/11/2026
      // adding form management
      {
        path: "/forms/manage",
        component: FormsIndexView,
        name: "forms-manage",
        meta: {
          permissions: {
            requiresAny: [
              "forms.list",
              "forms.get",
              "forms.submissions.list.self",
              "forms.submissions.list.any",
              "forms.submissions.create",
              "forms.submissions.get.self",
              "forms.submissions.get.any"
            ],
            requiresAll: [

            ],
          }
        }
      },
      {
        path: "/exports",
        component: () => import("../views/exports/ExportsView.vue"),
        name: "exports",
        meta: {
          permissions : {
            requiresAny: [
              "user.department.membership.request.export.any",
              "user.department.membership.request.export.department",
              "user.department.membership.request.view.operators.any",
              "absence.request.export",
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/assessments/manage",
        component: ManageAssessmentsActivationStatusIndexView,
        name: "assessments-manage",
        meta: {
          permissions: {
            requiresAny: [
              "assessment.activation.manage",
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/assessments/models",
        component: AssessmentModelsIndexView,
        name: "assessment-models",
        meta: {
          permissions : {
            requiresAny: [
              "assessment.model.list", 
              "assessment.model.get", 
              "assessment.model.create", 
              "assessment.model.update", 
              "assessment.model.delete"

            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/assessments/models/:id",
        component: AssessmentModelDetailsView,
        name: "assessment-model-details",
        meta: {
          permissions : {
            requiresAny: [
              "assessment.model.get",
              "assessment.model.update"
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/assessments/competencies/technical",
        component: TechnicalCompetenciesIndexView,
        name: "assessments-competencies-technical",
        meta: {
          permissions : {
            requiresAny: [
              "assessment.model.list", 
              "assessment.model.get", 
              "assessment.model.create", 
              "assessment.model.update", 
              "assessment.model.delete"

            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/assessments/competencies/personal",
        component: PersonalCompetenciesIndexView,
        name: "assessments-competencies-personal",
        meta: {
          permissions : {
            requiresAny: [
              "assessment.model.list", 
              "assessment.model.get", 
              "assessment.model.create", 
              "assessment.model.update", 
              "assessment.model.delete"

            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/assessments/objectives",
        component: null,
        name: "assessments-objectives",
        meta: {
          permissions : {
            requiresAny: [

            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/assessments/self",
        component: SelfAssessmentsIndexView,
        name: "assessments-self",
        meta: {
          permissions : {
            requiresAny: [
              "self.assessment.create.any", 
              "self.assessment.create.department", 
              "self.assessment.create.self", 
              "self.assessment.get.any", 
              "self.assessment.get.department", 
              "self.assessment.get.self", 
              "self.assessment.list.any", 
              "self.assessment.list.department", 
              "self.assessment.list.self", 
              "self.assessment.submit.any", 
              "self.assessment.submit.department",
              "self.assessment.submit.self", 
              "self.assessment.update.any", 
              "self.assessment.update.department", 
              "self.assessment.update.self", 
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        // NEXUS-148 - Alice Serina - 21/10/2026
        // introduced specification to allowed assessment types 
        path: "/assessments/:type(self|ascending|downward)/:id",
        component: AssessmentQuestionaireDetailsView,
        name: "assessment-type-details",
        meta: {
          // dynamically resolve needed permissions based on assessment type
          // passes in the route params
          permissionResolver: (to) => (
            assessmentDetailsPermissionsByType[to.params.type] ?? null
          ),

        },
      },
      {
        path: "/assessments/ascending",
        component: AscendingAssessmentsIndexView,
        name: "assessments-ascending",
        meta: {
          permissions : {
            requiresAny: [
              "ascending.assessment.create.any",
              "ascending.assessment.create.department", 
              "ascending.assessment.create.self", 
              "ascending.assessment.get.any", 
              "ascending.assessment.list.any", 
              "ascending.assessment.update.any", 
            ],
            requiresAll: [

            ],
          },
        },
      },
      {
        path: "/assessments/downward",
        component: DownwardAssessmentsIndexView,
        name: "assessments-downward",
        meta: {
          permissions : {
            requiresAny: [
              "downward.assessment.manage", 
              "downward.assessment.create.any", 
              "downward.assessment.create.department"

            ],
            requiresAll: [

            ],
          },
        },
      },
    ],
  },
  // NEXUS-148 - Alice Serina - 21/10/2026
  // this is a top-level-catch all for routes
  // it must always be the last route to ensure it only matches if
  // none of the routes actually matched.
  {
    path: "/:pathMatch(.*)*",
    redirect: {
          name: "not-found",
      },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
})

// Guard de autenticação
router.beforeEach((to) => {
    if (to.path.startsWith("/img/") || to.path.match(/\.(png|jpg|jpeg|ico|svg)$/)) {
        return true;
    }

    if (!keycloak.authenticated) {
        sessionStorage.setItem("redirectTo", to.fullPath);

        keycloak.login({
            redirectUri: window.location.origin + to.fullPath,
        });

        return false;
    }

    if (to.name === "Login") {
        return {name: "dashboard"};
    }
    // NEXUS-148 - Alice Serina - 21/10/2026
    // added route guarding based on each route's required permissions
    const sessionStore = useSessionStore(pinia);

    const resolvedPermissionRecords = to.matched
        // resolve permissions only for routes that have them or a resolver
        .filter((record) => (
            record?.meta?.permissions || record?.meta?.permissionResolver
        ))
        // resolve each route's permissions in case they have a resolver
        // instead of a play permissions object
        .map((record) => ({
            record,
            permissions: record?.meta?.permissionResolver
                ? record?.meta?.permissionResolver(to)
                : record?.meta?.permissions,
        }));

    const hasInvalidPermissionResolution = resolvedPermissionRecords.some(
        (resolvedRecord) => resolvedRecord.permissions === null,
    );
    // redirect to not found page if permission resolution fails somehow
    if (hasInvalidPermissionResolution) {
        return {
            name: "not-found",
        };
    }

    const canAccessRoute = resolvedPermissionRecords.every(
        ({ permissions }) => {
            const requiresAny = permissions.requiresAny ?? [];
            const requiresAll = permissions.requiresAll ?? [];

            return (
                (requiresAny.length === 0 || sessionStore.hasPermission(requiresAny)) &&
                (requiresAll.length === 0 || sessionStore.hasAllPermissions(requiresAll))
            );
        },
    );


    if (!canAccessRoute) {
        return {
            name: "forbidden",
        };
    }

    return true;
});


export default router
